//React
import React, { useCallback, useEffect, useState } from "react";
//Libs
import swal from "sweetalert";

//Services
import { producaov2 as api } from "../../../../services/apis";

//Components
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import { Box, Toolbar, FormControlLabel,Checkbox, Collapse, IconButton, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow, Typography, makeStyles, TextField, Button, CircularProgress } from '@material-ui/core';

import { IoIosArrowUp, IoIosArrowDown, IoMdCheckmark } from 'react-icons/io';
import { FilterList, HighlightOff } from '@material-ui/icons';
import { useRouter } from "../../../../hooks/router";

//Styles
import {
  Container, Content,
  Title
} from "./styles";
import { smallDateFormat } from "../../../../utils/Utils";

const stringMap = (str) => {
  switch (str) {
    case 1:
      return "Discordo totalmente"
    case 2:
      return ("Discordo parcialmente");
    case 3:
      return ("Não concordo nem discordo");
    case 4:
      return ("Concordo Parcialmente");
    case 5:
      return ("Concordo Totalmente");
    default:
      return ("Sem Resposta");
  }
}

function LoadingTable() {
  return (
    <Box
      position="absolute"
      top="0"
      bottom="0"
      left="0"
      right="0"
      height="100%"
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      <CircularProgress />
    </Box>
  )
}

function MapeamentoTableRow({ aluno }) {
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenDual, setIsOpenDual] = useState({});

  const handleDualClick = (id) => {
    setIsOpenDual(prevState => ({
      ...prevState,
      [id]: !prevState[id]
    }));
  };

  return (
    <>
      <TableRow key={aluno?.id}>
        <TableCell>
          <IconButton size="small" onClick={() => setIsOpen(prev => !prev)}>
            {isOpen ? <IoIosArrowUp color="#000" size="1em" /> : <IoIosArrowDown color="#000" size="1em" />}
          </IconButton>
        </TableCell>
        <TableCell>{aluno?.id}</TableCell>
        <TableCell>{aluno?.nome}</TableCell>
        <TableCell>{aluno?.email}</TableCell>
        <TableCell>{smallDateFormat(aluno?.data_answer)}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
          <Collapse in={isOpen} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>ID Pergunta</TableCell>
                    <TableCell>Pergunta</TableCell>
                    <TableCell>Resposta</TableCell>
                    <TableCell>Registro</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {aluno.responses?.map((alunoResponse, index) => {
                    const subQuestions = alunoResponse.subquestions;
                    const answers = alunoResponse.answer.split(',');

                    return (
                      <React.Fragment key={index}>
                        <TableRow>
                          <TableCell>
                            {
                              subQuestions && subQuestions.length > 0 && (
                                <IconButton size="small" onClick={() => handleDualClick(alunoResponse.id_question)}>
                                  {isOpenDual[alunoResponse.id_question] ? <IoIosArrowUp color="#000" size="1em" /> : <IoIosArrowDown color="#000" size="1em" />}
                                </IconButton>
                              )
                            }
                            {alunoResponse.id_question}
                          </TableCell>
                          <TableCell>{alunoResponse.question_text}</TableCell>
                          <TableCell>{alunoResponse.answer}</TableCell>
                          <TableCell>{alunoResponse?.data_sys ? smallDateFormat(alunoResponse.data_sys) : ''}</TableCell>
                        </TableRow>
                        {isOpenDual[alunoResponse.id_question] && subQuestions && (
                          <TableRow>
                            <TableCell colSpan={4} style={{ paddingBottom: 0, paddingTop: 0 }}>
                              <Collapse in={isOpenDual[alunoResponse.id_question]} timeout="auto" unmountOnExit>
                                <Box margin={1}>
                                  <Table size="small">
                                    <TableHead>
                                      <TableRow>
                                        <TableCell>Sub-Pergunta</TableCell>
                                        <TableCell>Resposta</TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {subQuestions.split(",").map((subQuestion, subIndex) => (
                                        <TableRow key={subIndex}>
                                          <TableCell>{subQuestion}</TableCell>
                                          <TableCell>{stringMap(Number(answers[subIndex]))} - {answers[subIndex]}</TableCell>
                                        </TableRow>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </Box>
                              </Collapse>
                            </TableCell>
                          </TableRow>
                        )}
                      </React.Fragment>
                    );
                  })}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}



const useStyles = makeStyles(() => ({
  body: {
    position: 'relative',
  },
  emptyBody: {
    height: '300px',
  },
  loadingOverlay: {
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
    backdropFilter: 'blur(5px)',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
}));

const useTableStyles = makeStyles({
  root: {
    width: "100%",
  },
  container: {
    height: "60vh",
    overflow: 'auto',
    position: "relative",
  },
  body: {

  },
  headCell: {
    wordBreak: 'keep-all',
    whiteSpace: 'nowrap'
  },
  projectSelect: {
    minWidth: '160px',
    display: "flex",
    flexGrow: 1,
    flexShrink: 1,
  },
  approvalSelect: {
    minWidth: '180px',
    display: "flex",
    flexGrow: 1,
    flexShrink: 1,
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "1rem",
    flexWrap: "wrap"
  },
  toolbarInputs: {
    display: "flex",
    gap: "2rem",
    flexGrow: 1,
    flexShrink: 1,
  },
  toolbarButtons: {
    display: "flex"
  }
});

const ListarMapeamento = () => {
  // const [search, setSearch] = useState("");
  const [data, setData] = useState([]);
  const [totalPage, setTotalPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const classnames = useStyles();
  const router = useRouter();

  const tableStyles = useTableStyles();

  const [params, setParams] = useState({
    page: 1,
    search: '',
    limit: 30,
    isMba: false,
    isPaying: false,
    isPro: false,
    isTrail: false,
  });

  

  
  const loadingPep = useCallback(
      async () => {
        setLoading(true);
        try {
          const response = await api.get("general/pep/questions-with-answer",{
            params
          });
  
          if(response.data){
            setData(response.data.data);
            setTotalPage(response.data.count);
            setLoading(false);
          }
        } catch (err) {
          swal(`Não foi possível carregar os cursos`, err, "error");
          setLoading(false);
        }
      },
      [params]
    );

  useEffect(() => {
    if(router.query.id_aluno){
      setParams(prev => ({ ...prev, search: router.query.id_aluno }));
      loadingPep();
      return;
    }
  
    loadingPep();
  }, []);

  const handleDeleteFilters = (e) => {
    setParams({
      page: 1,
      search: '',
      limit: 30,
      isMba: false,
      isPaying: false,
      isPro: false,
      isTrail: false,
    });
  }


  return (
    <Container>
      <AdminMenu />
      <Content>
        <Title>Controle - Mapeamento de Competências</Title>
            <Toolbar className={tableStyles.toolbar} >
              <Box className={tableStyles.toolbarInputs}>
                <TextField label="Aluno" value={params.search || ""} onChange={e => {
                  const value = e.target.value;
                  setParams(prev => ({ ...prev, search: value }));
                }} />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={params.isMba}
                      onChange={e => setParams(prev => ({ ...prev, isMba: !prev.isMba }))}
                      name="isMba"
                      color="primary"
                      id="isMba"
                    />
                  }
                  label="MBA"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={params.isPaying}
                      onChange={e => setParams(prev => ({ ...prev, isPaying: !prev.isPaying }))}
                      name="isPaying"
                      color="primary"
                      id="isPaying"
                    />
                  }
                  label="Pagantes"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={params.isPro}
                      onChange={e => setParams(prev => ({ ...prev, isPro: !prev.isPro }))}
                      name="isPro"
                      color="primary"
                      id="isPro"
                    />
                  }
                  label="Voitto PRO"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      id="isTrail"
                      checked={params.isTrail}
                      onChange={e => setParams(prev => ({ ...prev, isTrail: !prev.isTrail }))}
                      name="isTrail"
                      color="primary"
                    />
                  }
                  label="Trilha"
                />
              </Box>
              <Box className={tableStyles.toolbarButtons}>
              <IconButton
                variant="contained"
                color="primary"
                type="button"
                onClick={() => loadingPep()}
                style={{
                  fontSize:"1rem"
                }}
              >
                Aplicar Filtro <FilterList />
              </IconButton>
              {(params.isMba || params.isPaying || params.isPro || params.isTrail || params.search) && (
                <IconButton
                  variant="outlined"
                  color="primary"
                  type="button"
                  onClick={handleDeleteFilters}
                >
                  <HighlightOff />
                </IconButton>
              )}
            </Box>
            </Toolbar>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell>ID Aluno</TableCell>
              <TableCell>Nome</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Registro</TableCell>
            </TableRow>
          </TableHead>
          <TableBody className={`${classnames.body} ${data?.length === 0 && classnames.emptyBody}`}>
            {loading && (
              <Box
              position="absolute"
              top="100px"
              bottom="0"
              left="0"
              right="0"
              height="100%"
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <LoadingTable />
              </Box>
            )}
            {!loading && data?.sort((a,b) => {
  return new Date(b.data_answer).getTime() - new Date(a.data_answer).getTime();
})
            .map(aluno => {
              return (
                <MapeamentoTableRow aluno={aluno} />
              )
            })}
          </TableBody>

        </Table>
        {/* {!loading && (
            <TablePagination
              component="div"
              count={totalPage}
              page={params.page}
              rowsPerPage={params.limit}
              rowsPerPageOptions={[]}
              onChangePage={(_, newPage) => setParams(prev => ({ ...prev, page: newPage }))}
            />
          )} */}
      </Content>
    </Container>
  );
};

export default ListarMapeamento;
